import Logger from '@sm360/logger-sentry';
import { isEmpty, isString } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { ConfigsService, LocaleService } from '@sm360/widget-commons-core-services';
import { InputAutoComplete } from '@sm360/widget-commons-forms';

import ShowroomCBBService from 'trade-in/services/ShowroomCBBService/ShowroomCBBService.js';
import NewTradeInContext from '../../NewTradeInContext';

class CBBAutoComplete extends Component {
    constructor(props) {
        super(props);

        this.state = {
            autoCompleteValues: [],
            isLoading: false,
        };

        this.handleReset = this.handleReset.bind(this);
        this.handleSelectedOption = this.handleSelectedOption.bind(this);
        this.initializeAutoCompleteValues = this.initializeAutoCompleteValues.bind(this);
        this.updateAutocompleteValues = this.updateAutocompleteValues.bind(this);
        // TODO: newTradeIn - Remove updateAutocompleteValuesOld after deploy new tradeIn to the PROD
        this.updateAutocompleteValuesOld = this.updateAutocompleteValuesOld.bind(this);

        this.logger = new Logger(this.constructor.displayName, ConfigsService.getLoggerContext());

        this.inputAutoCompleteRef = null;
    }

    componentDidMount() {
        this.initializeAutoCompleteValues(this.props);
    }

    componentWillReceiveProps(newProps) {
        this.initializeAutoCompleteValues(newProps);
    }

    static contextType = NewTradeInContext;

    handleReset() {
        this.setState({
            autoCompleteValues: [],
        });
        this.props.onValueSelected('', null, null);
    }

    handleSelectedOption(inputValue, handler) {
        const selectedValue = this.state.autoCompleteValues.find((item) => item.value === inputValue);
        this.props.onValueSelected(inputValue, selectedValue, handler);
    }

    initializeAutoCompleteValues(props) {
        if (!this.state.autoCompleteValues.length && props.value !== '') {
            // TODO: newTradeIn - Remove condition after deploy new tradeIn to the PROD
            // eslint-disable-next-line no-unused-expressions
            this.context.displayNewTradeIn
                ? this.updateAutocompleteValues(props.value)
                : this.updateAutocompleteValuesOld(props.value);
        }
    }

    // updateAutocompleteValuesOld - Code with the current tradeIn logic
    // TODO: newTradeIn - Remove updateAutocompleteValuesOld after deploy new tradeIn to the PROD
    updateAutocompleteValuesOld(value) {
        if (!isString(value) || isEmpty(value)) {
            this.logger.debug(`Value must be a non-empty string but got ${value}`);
            return;
        }

        ShowroomCBBService.searchAutocomplete(value)
            .then((items) => {
                this.setState({
                    autoCompleteValues: items.map((item) => ({
                        id: item.name,
                        value: item.name,
                        ...item,
                    })),
                });
            })
            .catch((e) => {
                this.logger.error(
                    'CBBAutoComplete#updateAutocompleteValues error calling ShowroomCBBService.searchAutocomplete',
                    e,
                    value
                );
                this.setState({
                    autoCompleteValues: [],
                });
            });
    }

    updateAutocompleteValues(value) {
        this.setState({
            isLoading: true,
        });
        if (!isString(value) || isEmpty(value)) {
            this.logger.debug(`Value must be a non-empty string but got ${value}`);
            return;
        }

        const tradeVehicleQuery = {
            query: value,
        };

        ShowroomCBBService.searchCatalogVehicles(tradeVehicleQuery)
            .then((results) => {
                this.setState({
                    autoCompleteValues: results.map((item, i) => ({
                        id: i,
                        name: item.value,
                        value: item.value,
                        make: item.make,
                        model: item.model,
                        year: item.year,
                        style: item.style,
                        trim: item.trim,
                        exteriorColors: item.exteriorColors,
                        interiorColors: item.interiorColors,
                        options: item.options,
                        tradeVehicleToken: item.tradeVehicleToken,
                        vin: item.vin,
                    })),
                    isLoading: false,
                });
            })
            .catch((e) => {
                this.logger.error(
                    'CBBAutoComplete#updateAutocompleteValues error calling ShowroomCBBService.searchCatalogVehicles',
                    e,
                    value
                );
                this.setState({
                    autoCompleteValues: [],
                    isLoading: false,
                });
            });
    }

    validateInput() {
        return this.inputAutoCompleteRef ? this.inputAutoCompleteRef.validateInput() : Promise.resolve(false);
    }

    render() {
        return (
            <InputAutoComplete
                errorLabel={LocaleService.t('COMMONS_FORMS.ERRORS.DEFAULT')}
                isLoading={this.state.isLoading}
                // TODO: newTradeIn - Remove iconClassName after deploy new tradeIn to the PROD
                iconClassName="icon-review"
                items={this.state.autoCompleteValues}
                name="vehicleInformations"
                placeholder={LocaleService.t('TRADE_IN.AUTOCOMPLETE_CAR')}
                autoCompleteLabel={LocaleService.t('TRADE_IN.AUTOCOMPLETE_LABEL')}
                cantFindVehicleLabel={LocaleService.t('TRADE_IN.CANT_FIND_VEHICLE')}
                // TODO: newTradeIn - Remove condition after deploy new tradeIn to the PROD
                refreshItems={
                    this.context.displayNewTradeIn ? this.updateAutocompleteValues : this.updateAutocompleteValuesOld
                }
                suggestionsToDisplay={10}
                value={this.props.value}
                onResetValue={this.handleReset}
                onSelectedOption={this.handleSelectedOption}
                dataTestPrefix={this.props.dataTestPrefix}
                parentClassName={this.props.parentClassName}
                ref={(element) => {
                    this.inputAutoCompleteRef = element;
                }}
                isRequired
                // TODO: newTradeIn - Remove displayNewTradeIn after deploy new tradeIn to the PROD
                displayNewTradeIn={this.context.displayNewTradeIn}
                displayOnWrapper={this.props.displayOnWrapper}
            />
        );
    }
}

CBBAutoComplete.defaultProps = {
    value: '',
    dataTestPrefix: '',
    parentClassName: '',
    displayOnWrapper: '',
};

CBBAutoComplete.propTypes = {
    onValueSelected: PropTypes.func.isRequired,
    value: PropTypes.string,
    dataTestPrefix: PropTypes.string,
    parentClassName: PropTypes.string,
    displayOnWrapper: PropTypes.bool,
};

CBBAutoComplete.displayName = 'CBBAutoComplete';

export default CBBAutoComplete;
